module.exports = __webpack_public_path__ + "img/bell_2.7c33b5a7.jpg";